type listener = (data: any) => void

interface Subscriptions {
  [key: string]: listener[]
}

interface PostMessage {
  code: string
  group?: string
  [key: string]: any
}

type WindowController = WindowProxy | null

interface PostMessageControllerOption {
  postWin: WindowController
  postOrigin: string
  group?: string
}

export default class PostMessageController {
  postOrigin: string = ''
  postWin: WindowProxy | null = null
  subscriptions: Subscriptions = {}
  group = 'cloud'

  constructor({ postWin, postOrigin, group }: PostMessageControllerOption) {
    this.postWin = postWin
    this.postOrigin = postOrigin
    this.group = group || this.group
    window.addEventListener('message', event => {
      if (event.origin !== this.postOrigin || event.data?.group !== this.group) {
        return
      }
      if (this.subscriptions['message']?.[Symbol.iterator]) {
        this.subscriptions['message'].forEach(f => f(event))
      }
      const data = event.data
      if (typeof data.code === 'string' && data.code !== 'message' && this.subscriptions[data.code]) {
        this.subscriptions[data.code].forEach(f => f(data))
      }
    })
  }

  post(message: PostMessage) {
    try {
      const finalMessage = Object.assign({ group: this.group }, message)
      this.postWin?.postMessage(finalMessage, this.postOrigin)
    } catch (error) {
      console.warn(error)
    }
  }

  subscribe(code: string, listener: listener) {
    this.subscriptions[code] = (this.subscriptions[code] || []).filter(c => c !== listener).concat(listener)
  }
}
